import { Box, Label } from '@apia/theme';
import { ILabelSelectedDay, TScheduleResult } from './types';
import { formatMessage } from '../../../../utils/util';

const SelectedDateInfo = ({
  labelSelectedDay,
  data,
}: {
  labelSelectedDay?: ILabelSelectedDay;
  data?: TScheduleResult;
}) => {
  return (
    <Box className="selectedDateInfo">
      {labelSelectedDay?.day && (
        <Label>
          {formatMessage(window.LBL_SCHED_SELECTED_DATE, {
            TOK1: labelSelectedDay?.day,
            TOK2: `${labelSelectedDay?.hour.slice(
              0,
              -2,
            )}:${labelSelectedDay.hour.slice(2)}`,
          })}
        </Label>
      )}
      {!labelSelectedDay?.day &&
        !data?.weekNotConfigured &&
        data?.tskSchDay && (
          <Label sx={{ display: 'block' }}>
            {window.LBL_SCHED_DATE_NOT_SELECTED}
          </Label>
        )}
    </Box>
  );
};

export default SelectedDateInfo;
